module.exports = __webpack_public_path__ + "static/media/question.51ab7517.mp3";